<template>
  <div
    :class="[
      'd-flex',
      {
        'flex-column': orientation === 'column',
        'flex-row flex-wrap flex-gap-row': orientation === 'row',
        'checkbox-grid': orientation === 'grid',
      },
    ]"
  >
    <div v-for="option in options" :key="`checkbox_option_${option.key}`" class="option">
      <v-row no-gutters align="center" style="height: 64px">
        <v-col xs="6">
          <v-checkbox
            :label="option.label"
            class="custom-checkbox"
            :value="option.key"
            v-model="modelValue"
            :rules="rules"
            :disabled="disabled"
            hide-details
          />
        </v-col>
        <v-col xs="6" v-if="showDetail(option)">
          <v-radio-group
            class="d-flex"
            v-if="option.detail?.type === 'radio'"
            v-model="detail[option.key]"
            row
            :rules="rules"
            hide-details="auto"
            color="primary"
            :disabled="disabled"
          >
            <v-radio
              v-for="(value, label) in option.detail?.options"
              color="primary"
              :key="label"
              :label="label"
              :value="value"
            />
          </v-radio-group>
          <v-text-field
            v-else
            outlined
            hide-details
            :disabled="disabled"
            :value="option.detail"
            v-model="detail[option.key]"
            :placeholder="option.detail?.placeholder ?? 'Detalhes do tratamento'"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'
import { PropOptions, WatchOptionsWithHandler } from 'vue'

/**
 * @typedef {(string|number)[]} ModelValue
 */

export default {
  name: 'CheckboxDetailGroup',
  props: {
    /** @type {PropOptions<ModelValue>} */
    value: {
      type: Object,
    },
    // /** @type {PropOptions<Record<string, string | number | boolean>>} */
    options: {
      type: Array,
      required: true,
    },
    /** @type {PropOptions<'row' | 'column' | 'grid'>} */
    orientation: {
      type: String,
      default: 'row',
    },
    /** @type {PropOptions<Array<(v: any) => boolean | string>>} */
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let modelValue = []
    let detail = {}

    if (!isEmpty(this.value)) {
      modelValue = cloneDeep(this.value.selected)
      detail = cloneDeep(this.value.detail)
    }

    return {
      modelValue,
      detail,
      other: {
        selected: false,
        /** @type {string?} */
        text: null,
      },
    }
  },
  methods: {
    handleOtherCheckboxChange(selected) {
      if (!selected) {
        return
      }
      this.other.text = ' '
      this.$nextTick(() => {
        this.other.text = ''
      })
    },
    handleOtherTextChange(text) {
      if (text?.length && !this.other.selected) {
        this.other.selected = true
      } else if (!text?.length && this.other.selected) {
        this.other.selected = false
      }
    },
    showDetail(option) {
      return this.modelValue.includes(option.key) && !option.detail?.disabled
    },
  },
  watch: {
    /** @type {WatchOptionsWithHandler<ModelValue>} */
    modelValue: {
      handler(value) {
        const values = cloneDeep(value)
        this.$emit('input', { selected: values, detail: this.detail })
      },
      deep: true,
    },
    detail: {
      handler(value) {
        this.$emit('input', { selected: this.modelValue, detail: value })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.custom-checkbox {
  margin: 0;
  padding: 0 0 0 12px;
}

.option:nth-child(even) {
  background-color: #f9fafe;
}

.custom-checkbox :deep(label) {
  font-size: 14px;
  color: var(--v-neutral-lighten17);
}

.custom-checkbox :deep(.v-input__slot) {
  font-size: 14px;
}

.custom-checkbox :deep(i) {
  font-size: 20px;
}

.custom-checkbox :deep(i.mdi-checkbox-blank-outline) {
  font-size: 20px;
}

.custom-checkbox :deep(.v-input--selection-controls__ripple) {
  font-size: 20px;
}

.custom-checkbox.other > :deep(.v-input__control > .v-input__slot) {
  align-items: start;
}

.custom-checkbox.other :deep(.v-input--selection-controls__input) {
  margin-top: 10px;
}

.flex-gap-row {
  row-gap: 8px;
  column-gap: 24px;
}

.checkbox-grid {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  align-items: start;
  row-gap: 4px;
  column-gap: 24px;
}

.checkbox-grid .custom-checkbox {
  min-height: 40px;
  max-height: 66px;
  align-items: center;
}
</style>
